import { isDefinedArray, reduce } from "et3-type-guards";

import ReportListItem from "../../../../components/reports-list-item";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getAuditStore from "../../../../stores/auditor-store/audit-store";
import { TReport } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { DEFAULT_REPORT_OBJECT } from "../../../../constants/input-entries-constants";

const ReportsBox = withLiteObserverAndTheme((props) => {
  const eventsData = getAuditStore().adminReportEventsData.get();
  const reportsData = eventsData.eventsList;
  const status = "pending";
  const { theme } = props;
  const { colors, unitX } = theme;
  const isReportsDataDefined = isDefinedArray(reportsData);

  const reportComponent = reportsData.map((item) => {
    const type = reduce(() => item.type, "");
    const eventID = reduce(() => item.id, 0);
    const date = reduce(() => item.date, "");
    const report: TReport = reduce(
      () => item.reportData,
      DEFAULT_REPORT_OBJECT
    );
    return (
      <ReportListItem
        key={report.reportId}
        pageName={"AUDITOR_AUDIT"}
        report={report}
        status={status}
        takenActionType={type}
        eventID={eventID}
        date={date}
        reportNumberFromPartition={0}
        reportsPartitionMaxNumber={0}
      />
    );
  });
  return isReportsDataDefined ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      width={1500}
      height={100}
      color={colors.all.white}
      style={{
        borderRadius: 45 * unitX
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-end"
        alignItems="center"
        withShadow={false}
        width={1500}
        height={100}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={20}
          text={i18n.get("REPORTS")}
          isSpan={false}
          color={colors.all.black}
          style={{
            width: 1440 * unitX,
            display: "flex",
            justifyContent: "flex-start"
          }}
        />
      </ET3Div>
      {reportComponent}
      <Et3Margin top={50} bottom={0} right={0} left={0} />
    </ET3Div>
  ) : null;
});
export default ReportsBox;
